// extracted by mini-css-extract-plugin
export var logo = "_br-2";
export var logoWrapper = "_br-1";
export var strip = "_br-0";